import { Sheet } from "@mui/joy";
import { Typography } from "@mui/material";

/**
 *
 * @param root0
 * @param root0.size
 * @param root0.url
 * @param root0.type
 * @returns {ReactElement} Cover page
 */
export function Cover({
  url,
  type,
  size = 42,
}: {
  size?: number;
  url: string;
  type: "project" | "season" | "contractor";
}) {
  if (url) return <img src={url} height={size} style={{ borderRadius: 8 }} />;

  let iconClass;
  if (type === "project") iconClass = "fa-regular fa-folder";
  if (type === "contractor") iconClass = "fa-solid fa-user-music";
  if (type === "season") iconClass = "fa-solid fa-ticket";
  return (
    <Sheet
      sx={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 8,
        background: "#eceff1",
      }}
      variant="soft"
    >
      <i style={{ color: "#b0bec5" }} className={iconClass}></i>
    </Sheet>
  );
}
